import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  Container,
  Menu
} from 'semantic-ui-react'

import {
  toIntOr1,
  toIntOr20
} from '_utils'

const pre = 5
const preD1 = (pre * 2) + 1

const setPageRange = ({
  total,
  perPage,
  pageNum
}) => {
  const lastPageNum = R.min(pageNum + preD1, Math.ceil(total / perPage)) + 1
  const firstPageNum = R.min(pageNum - pre, lastPageNum - preD1)
  return R.take(preD1,
    R.dropWhile(x => x < 1,
      R.range(firstPageNum, lastPageNum)
    )
  )
}

const PageLeft = ({
  disabled,
  goToPrevPage
}) => <Menu.Item disabled={disabled} icon='angle double left' onClick={goToPrevPage} />

PageLeft.propTypes = {
  disabled: PropTypes.bool,
  goToPrevPage: PropTypes.func
}

const PageRight = ({
  disabled,
  goToNextPage
}) => <Menu.Item disabled={disabled} icon='angle double right' onClick={goToNextPage} />

PageRight.propTypes = {
  disabled: PropTypes.bool,
  goToNextPage: PropTypes.func
}

const Page = ({
  num,
  pageNum,
  total,
  onClick
}) => <Menu.Item disabled={(pageNum === num)} name={`${num}`} onClick={onClick} />

Page.propTypes = {
  num: PropTypes.number,
  pageNum: PropTypes.number,
  total: PropTypes.number,
  onClick: PropTypes.func
}

const getShowing = ({pageNum, perPage, total}) => total > perPage
  ? `Showing ${(pageNum - 1) * perPage + 1} to ${(pageNum - 1) * perPage + perPage} of ${total}`
  : `Showing ${total}`

const Pagination = ({
  goToPage,
  pageNum = 1,
  perPage = 20,
  total = 0
}) => {
  const pageRange = setPageRange({total, perPage: toIntOr20(perPage), pageNum: toIntOr1(pageNum)})
  return (
    <Container fluid>
      <Menu pagination size='mini'>
        <PageLeft disabled={!(pageNum > 1 && total > 0)} goToPrevPage={(e) => goToPage({pageNum: pageNum - 1, perPage})} />
        { pageRange.map(p => <Page key={p} pageNum={pageNum} num={p} onClick={(e) => goToPage({pageNum: p, perPage})} />) }
        <PageRight disabled={!(pageNum < Math.ceil(total / perPage))} goToNextPage={(e) => goToPage({pageNum: pageNum + 1, perPage})} />
      </Menu>
      <Menu pagination size='mini'>
        <Menu.Item disabled name='Show' />
        <Menu.Item name='20' disabled={perPage === 20} onClick={(e) => goToPage({pageNum, perPage: 20})} />
        <Menu.Item name='50' disabled={perPage === 50} onClick={(e) => goToPage({pageNum, perPage: 50})} />
        <Menu.Item name='100' disabled={perPage === 100} onClick={(e) => goToPage({pageNum, perPage: 100})} />
        <Menu.Item disabled name={getShowing({pageNum, perPage, total})} />
      </Menu>

    </Container>
  )
}

Pagination.propTypes = {
  goToPage: PropTypes.func,
  pageNum: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number
}

export default Pagination



// WEBPACK FOOTER //
// ./webAdmin/views/pagination.js